import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';
import { Observable, isObservable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
   name: 'isNil',
})
export class IsNilPipe implements PipeTransform {
   transform(value: Observable<any> | any): Observable<boolean> {
      let value$: Observable<any>;
      if (isObservable(value)) {
         value$ = value as Observable<any>;
      } else {
         value$ = of(value);
      }
      return value$.pipe(map((x) => _.isNil(x)));
   }
}
